export function BudgetLogo({ className, labelled = false }: { className?: string; labelled?: boolean }) {
  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      role={labelled ? 'img' : undefined}
      aria-label={labelled ? 'Budget' : undefined}
      aria-hidden={labelled ? undefined : true}
    >
      <rect width="48" height="48" rx="10" className="fill-primary/10" />
      <path
        d="M13 31.5h22M14 17.5l10-4.5 10 4.5M16 20.5h16M17.5 23.5v8M24 23.5v8M30.5 23.5v8M15 35.5h18"
        className="stroke-primary"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
      <path
        d="M14 29l6-5 5 3 8-8"
        className="stroke-foreground"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
      <circle cx="33" cy="19" r="2.5" className="fill-foreground" />
    </svg>
  )
}
